// Auto-split from i18n.js — language: ko_KR
export default {
    translation: {
        // routes & menus
        Dashboard: '대시보드',
        'Space Data': '공간 데이터',
        'Equipment Data': '장비 데이터',
        'Meter Data': '계량기 데이터',
        'Tenant Data': '임차인 데이터',
        'Store Data': '매장 데이터',
        'Shopfloor Data': '작업장 데이터',
        'Combined Equipment Data': '복합 장비 데이터',
        'Auxiliary System': '보조 시스템',
        Microgrid: '마이크로그리드',
        'Energy Storage Power Station': '에너지 저장 발전소',
        'Photovoltaic Power Station': '태양광 발전소',
        'Fault Alarm': '고장 알람',
        Monitoring: '장비 모니터링',
        'Advanced Reporting': '고급 보고서',
        'Knowledge Base': '지식 베이스',
        'Energy Category Data': '에너지 분류 분석',
        'Energy Item Data': '에너지 항목 분석',
        Carbon: '탄소 배출 분석',
        Cost: '비용 분석',
        Output: '산출 분석',
        Income: '수입 분석',
        Efficiency: '효율 분석',
        Load: '부하 분석',
        Statistics: '통계 분석',
        'Batch Analysis': '일괄 분석',
        Saving: '에너지 절약 분석Ⓔ',
        Plan: '계획 분석Ⓔ',
        Prediction: '예측 분석Ⓔ',
        'Production': '생산량',
        'Space Production': '생산량 에너지 소비 분석',
        'Equipment Tracking': '장비 대장',
        'Equipment Comparison': '비교 분석',
        'Shopfloor Comparison': '비교 분석',
        'Store Comparison': '비교 분석',
        'Space Comparison': '비교 분석',
        'Combined Equipment Comparison': '비교 분석',
        'Tenant Comparison': '비교 분석',
        'Environment Monitor': '환경 모니터링',
        'Meter Energy': '계량기 에너지 소비 분석',
        'Meter Prediction': '계량기 예측Ⓔ',
        'Virtual Meter Prediction': '가상 계량기 예측Ⓔ',
        'Offline Meter Prediction': '오프라인 계량기 예측Ⓔ',
        'Meter Carbon': '계량기 탄소 배출 분석',
        'Meter Cost': '계량기 비용 분석',
        'Meter Trend': '계량기 추세 분석',
        'Meter Realtime': '계량기 실시간 분석',
        'Meter Saving': '계량기 에너지 절약 분석Ⓔ',
        'Meter Plan': '계량기 계획 분석Ⓔ',
        'Master Meter Submeters Balance': '주계량기 및 부계량기 균형 분석',
        'Meter Batch Analysis': '계량기 일괄 분석',
        'Meter Comparison': '계량기 비교 분석',
        'Meter Tracking': '계량기 대장',
        'Virtual Meter Saving': '가상 계량기 에너지 절약 분석Ⓔ',
        'Virtual Meter Plan': '가상 계량기 계획 분석Ⓔ',
        'Virtual Meter Energy': '가상 계량기 에너지 소비 분석',
        'Virtual Meter Carbon': '가상 계량기 탄소 배출 분석',
        'Virtual Meter Cost': '가상 계량기 비용 분석',
        'Virtual Meter Batch Analysis': '가상 계량기 일괄 분석',
        'Virtual Meter Comparison': '가상 계량기 비교 분석',
        'Offline Meter Energy': '오프라인 계량기 에너지 소비 분석',
        'Offline Meter Carbon': '오프라인 계량기 탄소 배출 분석',
        'Offline Meter Cost': '오프라인 계량기 비용 분석',
        'Offline Meter Batch Analysis': '오프라인 계량기 일괄 분석',
        'Offline Meter Saving': '오프라인 계량기 에너지 절약 분석Ⓔ',
        'Offline Meter Plan': '오프라인 계량기 계획 분석Ⓔ',
        'Offline Meter Input': '오프라인 계량기 데이터 입력',
        'Tenant Bill': '임차인 청구서',
        'Energy Flow Diagram': '에너지 흐름도',
        'Distribution System': '배전 시스템',
        'SVG System': '구성 시각화 시스템',
        'Faults Data': '고장 분석',
        'Space Equipments': '공간 장비',
        'Combined Equipments': '복합 장비',
        'Energy Storage Power Station List': '발전소 목록',
        'Energy Storage Power Station Details': '장비 모니터링',
        'Energy Storage Power Station Reporting': '데이터 보고서',
        'Energy Storage Power Station Alarm': '고장 알람',
        'Energy Storage Power Station Maintenance': '유지 보수',
        'Enter Production': '생산량 입력',
        'Multiple Microgrids': '다중 발전소 데이터',
        'Multiple Microgrids Dashboard': '다중 발전소 대시보드',
        'Multiple Microgrids List': '발전소 목록',
        'Single Microgrid': '단일 발전소 데이터',
        'Single Microgrid Dashboard': '단일 발전소 대시보드',
        'Single Microgrid Details': '장비 데이터',
        'Single Microgrid Fault Alarm': '고장 알람',
        'Microgrid Reports': '통계 보고서',
        'Microgrid Reports Energy': '전력량 보고서',
        'Microgrid Reports Revenue': '수익 보고서',
        'Microgrid Reports Parameters': '데이터 조회',
        'Multiple Energy Storage Power Stations': '에너지 저장 다중 발전소 데이터',
        'Multiple Energy Storage Power Stations Dashboard': '에너지 저장 다중 발전소 대시보드',
        'Multiple Energy Storage Power Stations List': '에너지 저장 발전소 목록',
        'Single Energy Storage Power Station': '에너지 저장 단일 발전소 데이터',
        'Single Energy Storage Power Station Dashboard': '에너지 저장 단일 발전소 대시보드',
        'Single Energy Storage Power Station Details': '에너지 저장 장비 데이터',
        'Single Energy Storage Power Station Fault Alarm': '에너지 저장 고장 알람',
        'Energy Storage Power Station Reports': '에너지 저장 통계 보고서',
        'Energy Storage Power Station Reports Energy': '에너지 저장 전력량 보고서',
        'Energy Storage Power Station Reports Revenue': '에너지 저장 수익 보고서',
        'Energy Storage Power Station Reports Parameters': '에너지 저장 데이터 조회',
        'Multiple Photovoltaic Power Stations': '태양광 다중 발전소 데이터',
        'Multiple Photovoltaic Power Stations Dashboard': '태양광 다중 발전소 대시보드',
        'Multiple Photovoltaic Power Stations List': '태양광 발전소 목록',
        'Single Photovoltaic Power Station': '태양광 단일 발전소 데이터',
        'Single Photovoltaic Power Station Dashboard': '태양광 단일 발전소 대시보드',
        'Single Photovoltaic Power Station Details': '태양광 장비 데이터',
        'Single Photovoltaic Power Station Fault Alarm': '태양광 고장 알람',
        'Photovoltaic Power Station Reports': '태양광 통계 보고서',
        'Photovoltaic Power Station Reports Energy': '태양광 전력량 보고서',
        'Photovoltaic Power Station Reports Revenue': '태양광 수익 보고서',
        'Photovoltaic Power Station Reports Parameters': '태양광 데이터 조회',
        'Work Order': '작업 지시 관리',
        'Work Order Installation': '설치 기록',
        'Work Order Repair': '수리 기록',
        'Work Order Inspection': '점검 기록',
        'Total Number of Work Orders': '총 작업 지시 수',
        'Number of New Work Orders': '신규 작업 지시 수',
        'Number of Inprogress Work Orders': '진행 중 작업 지시 수',
        'Number of Done Work Orders': '완료된 작업 지시 수',
        'Fuel Indicator': '연료 소비량',
        'Charge Energy Indicator': '충전 에너지',
        'Discharge Energy Indicator': '방전 에너지',
        'Charge Cost Indicator': '충전 비용',
        'Discharge Revenue Indicator': '방전 수익',
        'HVAC': '공조',
        'Fire Control': '소방',
        'Store Dashboard': '매장 대시보드',
        'Comprehensive overview of store energy performance': '매장 에너지 성과 종합 개요',
        'Total Stores': '총 매장 수',
        'Total Area': '총 면적',
        'Active Meters': '활성 계량기',
        'Active Alerts': '활성 알림',
        'Total Energy Consumption': '총 에너지 소비량',
        'Carbon Emissions': '탄소 배출량',
        'Current Period': '현재 기간',
        'Energy Consumption by Category': '카테고리별 에너지 소비',
        'Cost Distribution by Category': '카테고리별 비용 분포',
        'Monthly Energy & Cost Trends': '월별 에너지 및 비용 추세',
        'Top 5 Energy Consuming Stores': '에너지 소비 상위 5개 매장',
        'Energy Category Details': '에너지 카테고리 세부정보',
        'Store Performance Overview': '매장 성과 개요',
        'YoY Change': '전년 대비',
        'Per m²': '㎡당',
        'Usage Intensity': '사용 강도',
        'Dashboard data loaded successfully': '대시보드 데이터 로드 성공',
        'Failed to load dashboard data': '대시보드 데이터 로드 실패',
        'Store Name': '매장 이름',
        'Store Area': '매장 면적',
        'Energy Consumption': '에너지 소비량',
        'Consumption': '소비량',
        'last period': '전기',
        // Tenant Dashboard
        'Tenant Dashboard': '테넌트 대시보드',
        'Comprehensive overview of tenant energy performance': '테넌트 에너지 성과 종합 개요',
        'Total Tenants': '총 테넌트 수',
        'Tenant Performance Overview': '테넌트 성과 개요',
        'Tenant Name': '테넌트 이름',
        'Tenant Area': '테넌트 면적',
        'Tenant Type': '테넌트 유형',
        // Equipment Dashboard
        'Equipment Dashboard': '장비 대시보드',
        'Total Equipments': '전체 장비 수',
        'Equipment Performance Overview': '장비 성능 개요',
        'Equipment Name': '장비 이름',
        'Equipment Type': '장비 유형',
        'Total Energy': '전체 에너지',
        'Total Sensors': '전체 센서 수',
        'Increment Rate': '증가율',
        // Shopfloor Dashboard
        'Total Shopfloors': '총 작업장 수',
        'Shopfloor Performance Overview': '작업장 성과 개요',
        'Shopfloor Name': '작업장 이름',
        'Shopfloor Area': '작업장 면적',
        // Combined Equipment Dashboard
        'Total Combined Equipments': '총 복합 장비 수',
        'Combined Equipment Performance Overview': '복합 장비 성과 개요',
        'Combined Equipment Name': '복합 장비 이름',
        'Associated Equipments': '관련 장비 수',

        // Dashboard
        'Welcome to QiXuan': 'QiXuan에 오신 것을 환영합니다',
        'An Industry Leading Energy Management System': '업계를 선도하는 에너지 관리 시스템',
        "This Year's Consumption CATEGORY VALUE UNIT": '올해 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
        "This Year's Costs CATEGORY VALUE UNIT": '올해 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
        "This Month's Consumption CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
        "This Month's Generation CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 생산 {{VALUE}}',
        "This Month's Costs CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '작년 동기 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '작년 동기 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} {{UNIT}} 소비',
        'CATEGORY Costs UNIT': '{{CATEGORY}} {{UNIT}} 비용',
        // Entities
        Space: '공간',
        Equipment: '장비',
        Meter: '계량기',
        'Offline Meter': '오프라인 계량기',
        'Virtual Meter': '가상 계량기',
        Tenant: '임차인',
        Store: '매장',
        Shopfloor: '작업장',
        'Combined Equipment': '복합 장비',
        'Cost Center': '비용 센터',
        Name: '이름',
        DisplayName: '표시 이름',
        UserName: '사용자 이름',
        Description: '설명',
        'Energy Category': '에너지 분류',
        'Child Spaces': '하위 공간',
        'Associated Equipment': '관련 장비',
        //Energy Categories
        Electricity: '전기',
        Water: '수도',
        'Natural Gas': '천연가스',
        // SidePanelModal
        Settings: '설정',
        'Set your own customized style': '사용자 정의 스타일 설정',
        'Color Scheme': '색 구성표',
        'Choose the perfect color mode for your app': '앱에 적합한 색상 모드 선택',
        Light: '밝은 모드',
        Dark: '어두운 모드',
        'RTL Mode': 'RTL 모드',
        'Switch your language direction': '언어 방향 전환',
        'Fluid Layout': '유동 레이아웃',
        'Toggle container layout system': '컨테이너 레이아웃 시스템 전환',
        'Navigation Position': '네비게이션 위치',
        'Vertical': '수직',
        'Top': '상단',
        'Combo': '콤보',
        'Transparent': '투명',
        'Inverted': '반전',
        'Card': '카드',
        'Vibrant': '활기',
        'Select a suitable navigation system for your web application': '웹 애플리케이션에 적합한 네비게이션 시스템 선택',
        'Vertical Nav': '수직 네비게이션',
        'Top Nav': '상단 네비게이션',
        'Vertical Navbar Style': '수직 네비게이션바 스타일',
        'Switch between styles for your vertical navbar': '수직 네비게이션바 스타일 전환',
        Language: '언어',
        'Switch between languages': '언어 전환',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': '시스템이 마음에 드시나요?',
        'Get QiXuan now': '지금 QiXuan를 받으세요',
        'PQ.About': '본 분석은 전압 편차, 전압 불평형, 주파수 편차 및 전류 불평형을 포함합니다. 전압 편차는 (U−Un)/Un×100%로 계산되며, 주파수 편차는 |f−fn|으로 계산됩니다. 3상 불평형은 max(|Xi−Xavg|)/Xavg×100%로 계산되며, 3상 채널 시간 동기화가 필요합니다. 결과는 선택된 계량기의 보고 기간 동안 시계열을 기반으로 합니다. 3상 채널이 없거나 타임스탬프가 일치하지 않으면 불평형 지표는 건너뜁니다. 순간적인 스파이크 또는 샘플 누락은 최악의 값을 증폭시킬 수 있으며, 정상 상태 평가는 합격률 및 P95와 같은 통계 지표를 참조하는 것이 좋습니다.',
        Purchase: '엔터프라이즈 버전 구매',
        ContactInfo: '연락처 정보',
        ProductWebsite: '제품 웹사이트',
        CompanyWebsite: '회사 웹사이트',
        SalesPhone: '영업 전화',
        // Query Panels
        'Base Period Begins': '기준 기간 시작',
        'Base Period Ends': '기준 기간 종료',
        'Comparison Types': '비교 유형',
        'Year-Over-Year': '전년 대비',
        'Month-On-Month': '전월 대비',
        'Free Comparison': '자유 비교',
        'None Comparison': '비교 없음',
        'Reporting Period Begins': '보고 기간 시작',
        'Reporting Period Ends': '보고 기간 종료',
        '(Optional)': '(선택 사항)',
        'Period Types': '시간 단위',
        Yearly: '연간',
        Monthly: '월간',
        Weekly: '주간',
        Daily: '일간',
        Hourly: '시간별',
        Submit: '제출',
        'Input Energy Category': '에너지 소비 분류',
        'Output Energy Category': '에너지 생산 분류',
        'Fraction Parameter': '분수 매개변수',
        Search: '검색',
        //DateRangePicker
        sunday: '일',
        monday: '월',
        tuesday: '화',
        wednesday: '수',
        thursday: '목',
        friday: '금',
        saturday: '토',
        ok: '확인',
        today: '오늘',
        yesterday: '어제',
        hours: '시',
        minutes: '분',
        seconds: '초',
        last7Days: '최근 7일',
        tomorrow: '내일',
        dayAfterTomorrow: '모레',
        next7Days: '앞으로 7일',
        'Select Date Range': '날짜 범위 선택',
        //Card Summaries and Line Charts
        'Base Period': '기준 기간',
        'Reporting Period': '보고 기간',
        'Per Unit Area': '단위 면적당 값',
        'Per Capita': '인당 값',
        'Per Unit Production': '단위 제품당 값',
        Baseline: '기준값',
        Actual: '실제값',
        'Baseline Value - Actual Value': '기준값 - 실제값',
        'Average Load': '평균 부하',
        'Maximum Load': '최대 부하',
        'Load Factor': '부하율',
        'Ratio of Average Load to Maximum Load': '평균 부하 대 최대 부하 비율',
        'Carbon Dioxide Emissions by Energy Category': '이산화탄소 배출 비율',
        'Costs by Energy Category': '비용 비율',
        'Incomes by Energy Category': '수입 비율',
        'Electricity Consumption by Time-Of-Use': '시간대별 전력 소비',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': '시간대별 전력 이산화탄소 배출',
        'Electricity Cost by Time-Of-Use': '시간대별 전력 비용',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 항목별 소비 비율',
        'Ton of Standard Coal by Energy Category': '톤 표준 석탄(TCE) 비율',
        'Ton of Carbon Dioxide Emissions by Energy Category': '톤 이산화탄소 배출(TCO2E) 비율',
        'Reporting Period Consumption CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 소비',
        'Reporting Period Prediction CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 예측',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 소비',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 소비',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': '보고 기간 {{PRODUCT}} {{VALUE}} {{UNIT}} 생산',
        'Base Period Production PRODUCT VALUE UNIT': '기준 기간 {{PRODUCT}} {{VALUE}} {{UNIT}} 생산',
        'Reporting Period Consumption CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Reporting Period Prediction CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 예측',
        'Base Period Consumption CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Base Period Prediction CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 예측',
        'Reporting Period Consumption ITEM CATEGORY UNIT': '보고 기간 {{ITEM}} {{CATEGORY}} {{UNIT}} 소비',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '보고 기간 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': '기준 기간 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Child Space Proportion CATEGORY UNIT': '하위 공간 {{CATEGORY}} {{UNIT}} 비율',
        'Child Space Total Proportion': '하위 공간 총 비율',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 이산화탄소 배출',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 이산화탄소 배출',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 이산화탄소 배출',
        'Reporting Period Costs CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 비용',
        'Reporting Period Costs CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 비용',
        'Base Period Costs CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 비용',
        'Reporting Period Output CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 생산',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 생산',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 생산',
        'Reporting Period Output CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 생산',
        'Base Period Output CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 생산',
        'Reporting Period Income CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 수입',
        'Reporting Period Income CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 수입',
        'Base Period Income CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 수입',
        'Reporting Period Total Income UNIT': '보고 기간 총 수입 {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': '보고 기간 누적 효율 {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 보고 기간 누적 효율 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} 보고 기간 누적 종합 효율 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 보고 기간 누적 종합 효율 {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 기준 기간 누적 종합 효율 {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': '순간 효율 {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 순간 효율 {{UNIT}}',
        'Equipment Efficiency Indicator': '장비 에너지 효율 지표',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 순간 종합 효율 {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': '보고 기간 누적 효율 {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '보고 기간 누적 효율 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': '기준 기간 누적 효율 {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': '기준 기간 누적 효율 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': '기준 기간 {{CATEGORY}} 최대 부하 {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': '보고 기간 {{CATEGORY}} 최대 부하 {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': '보고 기간 {{CATEGORY}} 평균 부하 {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': '보고 기간 {{CATEGORY}} 부하율',
        'Base Period CATEGORY Average Load VALUE UNIT': '기준 기간 {{CATEGORY}} 평균 부하 {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': '보고 기간 {{CATEGORY}} 평균 {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': '보고 기간 {{CATEGORY}} 최대값 {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': '보고 기간 {{CATEGORY}} 최소값 {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': '보고 기간 {{CATEGORY}} 산술 평균 {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': '보고 기간 {{CATEGORY}} 중앙값 {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': '보고 기간 {{CATEGORY}} 표본 표준 편차 {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': '보고 기간 {{CATEGORY}} 표본 분산 {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 절감 (기준 - 실제)',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 감소 (기준 - 실제)',
        'Reporting Period Saving CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 절감',
        'Base Period Saving CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 절감',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': '보고 기간 주계량기 {{CATEGORY}} {{UNIT}} 소비',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '보고 기간 주계량기 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Reporting Period Submeters Consumption CATEGORY UNIT': '보고 기간 부계량기 {{CATEGORY}} {{UNIT}} 소비',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '보고 기간 부계량기 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
        'Reporting Period Difference CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 차이',
        'Reporting Period Percentage Difference': '보고 기간 차이 백분율',
        'Reporting Period Difference CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 차이',
        'Trend Values': '추세 값',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': '고장 목록',
        'Reporting Period Number of Fault VALUE': '보고 기간 고장 수: {{VALUE}}',
        'All Faults': '모든 고장',
        'Space Faults': '공간 고장',
        'Number of All Faults': '전체 고장 수',
        'Number of Space Faults': '공간 고장 수',
        'Total Number of Faults': '총 고장 수',
        'Number of New Faults': '신규 고장 수',
        'Number of Inprogress Faults': '진행 중 고장 수',
        'Number of Done Faults': '완료된 고장 수',
        //Data Panels
        'Ton of Standard Coal': '톤 표준 석탄',
        'Ton of Carbon Dioxide Emissions': '톤 이산화탄소 배출',
        'Carbon Emissions Per Unit Of Energy Consumption': '단위 에너지 소비당 탄소 배출',
        'Operating Characteristic Curve': '운전 특성 곡선',
        Tariff: '요금',
        'Detailed Data': '상세 데이터',
        'Child Spaces Data': '하위 공간 데이터',
        'Associated Equipment Data': '관련 장비 데이터',
        'This Year': '올해',
        'The Same Period Last Year': '작년 동기',
        'This Month': '이번 달',
        'This Day': '오늘',
        Total: '총계',
        'No data found': '데이터 없음',
        Export: '내보내기',
        'AI Analysis': 'AI 분석',
        Datetime: '날짜 시간',
        'Time-Of-Use Type': '시간대별 유형',
        'Top-Peak': '최대',
        'On-Peak': '최고',
        'Mid-Peak': '중간',
        'Off-Peak': '최저',
        'Deep': '최저(심야)',
        Percentage: '백분율',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': '에너지 값 포인트 최근 1시간 추세',
        Circuit: '회로',
        Point: '데이터 포인트',
        'Realtime Value': '실시간 값',
        //Meter Tracking
        'Meter List': '계량기 목록',
        'Edit Meter': '편집',
        'Start Value': '시작 값',
        'End Value': '종료 값',
        'Difference Value': '차이 값',
        'Start Integrity Rate': '시작 데이터 무결성율(%)',
        'End Integrity Rate': '종료 데이터 무결성율(%)',
        'Full Integrity Rate': '전체 데이터 무결성율(%)',
        'Start Integrity Rate Description': '시작 데이터 완전성률: 통계 기간 내 모든 계량기 중 시작 시점 에너지 소비량 판독에 성공한 계량기의 비율',
        'End Integrity Rate Description': '종료 데이터 완전성률: 통계 기간 내 모든 계량기 중 종료 시점 에너지 소비량 판독에 성공한 계량기의 비율',
        'Full Integrity Rate Description': '전체 데이터 완전성률: 통계 기간 내 모든 계량기 중 시작 및 종료 시점 에너지 소비량 판독에 모두 성공한 계량기의 비율',
        //Equipment Tracking
        'Equipment List': '장비 목록',
        'Edit Equipment': '편집',
        //Profile Dropdown
        Feedback: '피드백',
        'Account Settings': '계정 설정',
        Logout: '로그아웃',
        //Authentication
        'Log in': '로그인',
        'Email address': '이메일 주소',
        'Phone Number': '전화번호',
        Password: '비밀번호',
        CaptchaCode: '인증 코드',
        Refresh: '새로 고침',
        'Remember me': '로그인 상태 유지',
        'Logged in as ': '다음으로 로그인됨 ',
        'Forgot Password?': '비밀번호를 잊으셨나요?',
        'Forgot your password?': '비밀번호를 잊으셨나요?',
        "Enter your email and we'll send you a reset link": '이메일을 입력하면 재설정 링크를 보내드립니다',
        "Enter your email and we'll send you a registration link": '이메일을 입력하면 등록 링크를 보내드립니다',
        'Reset Password': '비밀번호 재설정',
        'Thanks for using QiXuan!': 'QiXuan를 사용해 주셔서 감사합니다!',
        'You are now successfully signed out': '성공적으로 로그아웃되었습니다',
        'Return to Login': '로그인으로 돌아가기',
        'Please check your email!': '이메일을 확인하세요!',
        'An email has been sent to ': '이메일이 다음으로 발송되었습니다 ',
        'Please click on the included link to reset your password': '비밀번호를 재설정하려면 포함된 링크를 클릭하세요',
        'Please click on the included link to register your account': '계정을 등록하려면 포함된 링크를 클릭하세요',
        'An email with password reset link is sent to ': '비밀번호 재설정 링크가 포함된 이메일이 다음으로 발송되었습니다 ',
        'Change Password': '비밀번호 변경',
        'Old Password': '기존 비밀번호',
        'New Password': '새 비밀번호',
        'Confirm Password': '새 비밀번호 확인',
        'Update Password': '비밀번호 업데이트',
        'Password has been changed!': '비밀번호가 변경되었습니다!',
        'Verification code has been sent to your inbox. \
Please copy it to the input box below.':
            '인증 코드가 수신함으로 발송되었습니다. 아래 입력란에 복사하세요.',
        'New to QiXuan': 'QiXuan가 처음이신가요',
        'Create an account': '계정 생성',
        'EMAIL Account registration successful': '{{EMAIL}} 계정 등록 성공',
        'Thanks for verifying your account!': '계정 인증에 감사드립니다!',
        'Your code is': '귀하의 코드는',
        'Send verification code': '인증 코드 전송',
        'Please wait for NUMBER seconds': '{{NUMBER}}초 동안 기다려주세요',
        'Password reset': '비밀번호 재설정',
        'Please wait for approval': '승인을 기다려주세요',
        //notification
        Notifications: '알림',
        'Mark all as read': '모두 읽음으로 표시',
        'View all': '모두 보기',
        'Notification New': '새로운',
        'Notification Earlier': '이전',
        'Notification List': '알림 목록',
        'Bulk actions': '일괄 작업',
        'Notification Subject': '주제',
        'Notification Created Datetime': '생성 시간',
        'Notification Message': '내용',
        'Notification Priority': '우선순위',
        'Notification Status': '상태',
        'Notification Mark As Read': '읽음으로 표시',
        'Notification Mark As Acknowledged': '확인',
        'Notification Low': '낮음',
        'Notification Medium': '중간',
        'Notification High': '높음',
        'Notification Critical': '심각',
        'Notification Unread': '읽지 않음',
        'Notification Read': '읽음',
        'Notification Acknowledged': '확인됨',
        'Notification Archive': '보관',
        'Notification Delete': '삭제',
        'Notification Apply': '적용',
        'Notification Start Datetime': '시작 시간',
        'Notification End Datetime': '종료 시간',
        'Notification Update Datetime': '업데이트 시간',
        //Monitoring
        'Run Commands': '명령 실행',
        'Pin Code': '암호',
        'Unlock': '잠금 해제',
        'Set Value': '값 설정',
        'Fault Alarms': '고장 알람',
        'Instantaneous Efficiency VALUE UNIT': '순간 효율 {{VALUE}} {{UNIT}}',
        'Communication Status': '통신 상태',
        'Communication Online': '온라인',
        'Communication Offline': '오프라인',
        'Equipment Status': '장비 상태',
        'Equipment Running': '운전 중',
        'Equipment Stopped': '정지',
        'Show Up to': '페이지당 표시 수',
        All: '전체',
        'FROM - TO of TOTAL': '현재 {{FROM}} - {{TO}} 표시, 총 {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': '전력량',
        'Microgrid Revenue': '수익',
        'Microgrid Carbon': '탄소 배출',
        'Photovoltaic Generation': '태양광 발전량',
        'EV Charger Consumption': '전기차 충전기 소비량',
        'Load Consumption': '부하 소비량',
        'Grid Buy': '전력망 구매량',
        'Grid Sell': '전력망 판매량',
        'EV Charger': '전기차 충전기',
        'Heat Pump': '히트펌프',
        'Photovoltaic': '태양광',
        'PCS Run State': 'PCS 운전 상태',
        'PCS Unknown': '알 수 없음',
        'PCS Initializing': '초기 전원 공급',
        'PCS Standby': '대기',
        'PCS Shutdown': '종료',
        'PCS Fault': '고장',
        'PCS Running': '운전 중',
        'Battery Power': '배터리 전력',
        'Photovoltaic Power': '태양광 전력',
        'Grid Power': '전력망 전력',
        'Load Power': '부하 전력',
        Reporting: '데이터 보고서',
        Maintenance: '유지 보수',
        'General Information': '기본 정보',
        'Serial Number': '일련 번호',
        Address: '주소',
        'Postal Code': '우편번호',
        'Rated Capacity': '정격 용량',
        'Rated Power': '정격 출력',
        Latitude: '위도',
        Longitude: '경도',
        'Strategy Management': '전략 관리',
        'Charging Schedule': '충전 일정',
        'Charge Start Time': '충전 시작 시간',
        'Charge End Time': '충전 종료 시간',
        'Discharge Start Time': '방전 시작 시간',
        'Discharge End Time': '방전 종료 시간',
        'Total Rated Power': '총 정격 출력',
        'Total Rated Capacity': '총 정격 용량',
        // Energy Indicator
        "Today's Charge": "오늘 충전량",
        "Today's Discharge": "오늘 방전량",
        "Today's Generation": "오늘 발전량",
        'Total Fuel Consumption': '총 연료 소비량',
        'Total Charge': '총 충전',
        'Total Discharge': '총 방전',
        'Total Generation': '총 발전량',
        'Total Revenue': '총 수익',
        'Total Photovoltaic Generation': '총 태양광 발전량',
        'Total EV Charger Consumption': '전기차 충전기 총 소비량',
        'Total Load Consumption': '부하 총 소비량',
        'Total Grid Buy': '전력망 총 구매량',
        'Total Grid Sell': '전력망 총 판매량',
        'Total Efficiency': '종합 효율',
        'Discharge Achievement Rate': '방전 달성률',
        // Revenue Indicator
        "Today's Cost": "오늘 비용",
        "Today's Income": "오늘 수입",
        "Total Cost": "누적 비용",
        "Total Income": "누적 수입",
        "Today's Revenue": "오늘 수익",

        'Revenue Ranking': '수익 순위',
        'Efficiency Ranking': '효율 순위',
        'Charge Ranking': '충전 순위',
        'Discharge Ranking': '방전 순위',
        'Number of Microgrids': '마이크로그리드 수',
        'Number of Power Stations': '발전소 수',
        'Microgrid List': '마이크로그리드 목록',
        'Select Microgrid': '마이크로그리드 선택',
        'Previous Page': '이전 페이지',
        'Next Page': '다음 페이지',
        '7 Days': '7일',
        'Charge UNIT': '충전 {{UNIT}}',
        'Discharge UNIT': '방전 {{UNIT}}',
        'Generation UNIT': '발전 {{UNIT}}',
        'Energy Indicator': '에너지',
        'Revenue Indicator': '수익',
        'Carbon Indicator': '탄소',

        // Energy Storage Power Station
        'Battery Operating State': '배터리 운전 상태',
        'Battery State': '배터리 상태',
        'Battery Unknown': '알 수 없음',
        'Battery Stopped': '정지',
        'Battery Reserved': 'Reserved',
        'Battery Fault': '고장',
        'Battery Warning': '경고',
        'Battery Standby': '대기',
        'Battery Prohibit DisCharging': '방전 금지',
        'Battery Prohibit Charging': '충전 금지',
        'Battery Normal': '정상',
        'Battery Charging': '충전 중',
        'Battery Discharging': '방전 중',
        'Battery Idle': '유휴 상태',
        'Phase of Lifecycle': '단계',
        'Use Phase': '가동',
        'Commissioning Phase': '시운전',
        'Commissioning Date': '가동 날짜',
        'Installation Phase': '건설 중',
        'Device Status': '장비 상태',
        'Basic Information': '기본 정보',
        'Gateway': '게이트웨이',
        'Grid Meter': '전력망 계량기',
        'Load Meter': '부하 계량기',
        'ESS Meter': '에너지 저장 계량기',
        'Total Active Power': '총 유효 전력',
        'Active Power A': 'A상 유효 전력',
        'Active Power B': 'B상 유효 전력',
        'Active Power C': 'C상 유효 전력',
        'Total Reactive Power': '총 무효 전력',
        'Reactive Power A': 'A상 무효 전력',
        'Reactive Power B': 'B상 무효 전력',
        'Reactive Power C': 'C상 무효 전력',
        'Total Apparent Power': '총 피상 전력',
        'Apparent Power A': 'A상 피상 전력',
        'Apparent Power B': 'B상 피상 전력',
        'Apparent Power C': 'C상 피상 전력',
        'Total Power Factor': '총 역률',
        'Active Energy Import': '순방향 유효 전력',
        'Active Energy Export': '역방향 유효 전력',
        'Active Energy Net': '순 유효 전력',

        'Generator': '발전기',

        // Photovoltaic Power Station
        'Invertor': '인버터',
        'Invertor Run State': '인버터 운전 상태',
        'Invertor Unknown': '알 수 없음',
        'Invertor Initializing': '초기 전원 공급',
        'Invertor Standby': '대기',
        'Invertor Shutdown': '종료',
        'Invertor Fault': '고장',
        'Invertor Running': '운전 중',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': '생성 시간',
        'File Format': '파일 형식',
        'File Size': '파일 크기',
        Uploader: '업로더',
        'Upload Datetime': '업로드 시간',
        //Error
        "The page you're looking for is not found": '찾으시는 페이지를 찾을 수 없습니다',
        "Make sure the address is correct and that the page hasn't moved": '주소가 올바른지, 페이지가 이동되지 않았는지 확인하세요',
        'If you think this is a mistake,': '이것이 실수라고 생각되시면,',
        'contact us': '문의하기',
        'Take me home': '홈으로 이동',
        'Whoops, something went wrong!': '앗, 문제가 발생했습니다!',
        'Try refreshing the page, or going back and attempting the action again':
            '페이지를 새로 고침하거나, 돌아가서 작업을 다시 시도하세요',
        'If this problem persists,': '문제가 계속되면,',
        'Captcha Error': '인증 코드 오류',
        'Confirm Password Error': '비밀번호 불일치',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            '유효하지 않은 비밀번호 재설정 링크를 클릭한 것 같습니다. 다시 시도해 주세요.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            '유효하지 않은 계정 등록 링크를 클릭한 것 같습니다. 다시 시도해 주세요.',
        //Tenant Bill
        'Lease Contract Number': '임대 계약 번호',
        Download: '다운로드',
        Print: '인쇄',
        'Payment Notice': '지불 안내서',
        'Bill To': '수취인',
        'Bill Number': '청구서 번호',
        'Bill Date': '청구서 날짜',
        'Payment Due Date': '지불 기한',
        'Amount Payable': '지불 금액',
        'Billing Period Start': '청구 기간 시작일',
        'Billing Period End': '청구 기간 종료일',
        Quantity: '수량',
        Price: '단가',
        Unit: '단위',
        Amount: '금액',
        Subtotal: '소계',
        'VAT Output Tax': '부가가치세 출력 세금',
        'Total Amount Payable': '총 지불 금액',
        'Please make sure to pay on or before the payment due date above': '위 지불 기한 또는 그 이전에 지불해 주십시오',
        'Send money to the following account': '다음 계좌로 송금',
        'Account Name': '계좌 명의',
        'Bank Name': '은행 이름',
        'Bank Address': '은행 주소',
        'RMB Account': '위안 계좌',
        // button
        'Toggle Navigation': '네비게이션 전환',
        // working calendar
        'Working Days': '근무일',
        'Non Working Days': '비근무일',
        'Select Row': '작업할 데이터 행 선택',
        // Offline Meter Input
        'Daily Value': '일일 데이터',
        Date: '날짜',
        'Successfully Saved': '성공적으로 저장됨',
        'Previous Data Is Empty': '이전 데이터가 비어 있음',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external ID exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date is already in working calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report ID',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment ID',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter ID',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment UUIDs',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact ID',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center ID',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file ID',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source ID',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter UUID',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit ID',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system ID',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message ID',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server ID',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category ID',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item ID',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment ID',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter ID',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment UUID',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid FDD code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway ID',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file ID',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter ID',
        'API.INVALID_MENU_ID': 'Invalid menu ID',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter ID',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter UUID',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification ID',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter UUID',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file ID',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter ID',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter UUID',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space ID',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point ID',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege ID',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule ID',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor ID',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session, please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor ID',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor UUID',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node ID',
        'API.INVALID_SPACE_ID': 'Invalid space ID',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space UUID',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store ID',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type ID',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store UUID',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node ID',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff ID',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant ID',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type ID',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant UUID',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message ID',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone ID',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user ID',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user UUID',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter ID',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter ID',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter UUID',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message ID',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message ID',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar ID',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge file cannot be removed from disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day not found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': '유효하지 않은 오프라인 계량기 값',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'Passwords match',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be earlier than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There is relation with energy storage containers batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There is relation with energy storage containers grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There is relation with energy storage containers loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There is relation with energy storage containers power conversion systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'There is relation with virtual power plants',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers, please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User account has been locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User account has expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User password has expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User UUID not found in headers, please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: '주계량기',
        SubMeter: '부계량기',
        'Power Quality': '전력 품질',
        'About Power Quality': '전력 품질에 관하여',
        Category: '카테고리',
        Type: '유형',
        Limit: '한계',
        'Normal Limit': '정상 한계',
        'Severe Limit': '심각한 한계',
        Compliance: '합격률',
        'Worst Deviation': '최악 편차',
        'Worst Time': '최악 발생 시간',
        'Severe Exceed Count': '심각 초과 횟수',
        'Worst Unbalance': '최대 불평형률',
        Hz: '헤르츠',
        voltage: '전압',
        current: '전류',
        frequency: '주파수',
        voltage_deviation: '전압 편차',
        current_unbalance: '전류 불평형',
        voltage_unbalance: '전압 불평형',
        mean_deviation_pct: '평균 편차(%)',
        p95_abs_deviation_pct: 'P95 절대 편차(%)',
        mean_abs_deviation_hz: '평균 절대 편차(Hz)',
        frequency_deviation: '주파수 편차',
        p95_abs_deviation_hz: 'P95 절대 편차(Hz)',
        mean_unbalance_pct: '평균 불평형률(%)',
        p95_unbalance_pct: 'P95 불평형률(%)',
        count: '계수',
        min: '최소값',
        max: '최대값',
        mean: '평균',
        std: '표준 편차',
        p5: 'P5',
        p95: 'P95'
    }
};
